import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { MainContextProvider } from "./MainContext";
import "./index.scss";
import { HashRouter } from "react-router-dom";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <MainContextProvider>
        <HashRouter>
            <App />
        </HashRouter>
    </MainContextProvider>
);
